import React from 'react'
import Header from '../containers/Header/Header'
import Footer from '../containers/Footer/Footer'
import Appointment from '../components/Home/Appointment/Appointment'
import Popup from '../components/Common/Popup/Popup'
import ContactUs from '../components/ContactUs/ContactUs'

const Layout = ({children}) => {
  return (
    <>
    <Header/>
    <div className='content'>
    {children}

    </div>
    {/* <ContactUs/>
      <Footer/> */}
      <Footer/>
      {/* <Popup>
        <ContactUs/>
      </Popup> */}
    </>
  )
}

export default Layout
